// 로그인 랜딩 화면.
// 작업계획서 4.1: 소셜 3사 시작 버튼 + 휴대폰 번호 로그인 진입 버튼.
// 휴대폰 번호 입력/인증은 별도 화면(/login/phone)으로 분리한다(개선항목 3).

import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import SocialButtons from "@/features/auth/SocialButtons.tsx";
import { Button } from "@/shared/ui";

// 로그인 진입 화면 컴포넌트.
// 소셜 로그인 진입점 + "핸드폰 번호 시작하기" 버튼만 두고, 실제 입력은 후속 화면에서 처리한다.
export default function LoginPage() {
  const navigate = useNavigate();

  // 뒤로가기: 직전 화면이 있으면 그곳으로, 없으면 메인으로.
  function goBack() {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/", { replace: true });
    }
  }

  return (
    <main className="mx-auto flex min-h-dvh max-w-screen-sm flex-col gap-8 px-6 py-10">
      <header className="flex flex-col gap-2">
        <button
          type="button"
          onClick={goBack}
          aria-label="뒤로"
          className="-ml-2 inline-flex h-10 w-10 items-center justify-center rounded-full text-ink-700 hover:bg-ink-100"
        >
          <ChevronLeft size={24} aria-hidden="true" />
        </button>
        <h1 className="text-2xl font-bold">로그인</h1>
        <p className="text-base text-ink-600">소셜 계정 또는 휴대폰 번호로 시작하실 수 있습니다.</p>
      </header>

      <SocialButtons />

      <div className="flex items-center gap-3">
        <span className="h-px flex-1 bg-ink-200" />
        <span className="text-sm text-ink-600">또는</span>
        <span className="h-px flex-1 bg-ink-200" />
      </div>

      {/* 휴대폰 번호 로그인 화면(/login/phone)으로 이동 */}
      <Button type="button" variant="secondary" fullWidth onClick={() => navigate("/login/phone")}>
        핸드폰 번호 시작하기
      </Button>
    </main>
  );
}
